import ContentEditor from '@/jquery/widgets/contentEditor'

export default {
  init: function( editor ) {
    if (
      !window.vue ||
      !window.vue.$store.state.app.features.subscriptionPreferences
    ) {
      return;
    }

    editor.ui.addButton( 'Preferences', {
      label: 'Preferences',
      toolbar: 'insert',
      icon: '/img/icon/consent.svg'
    });

    editor.on('uiSpace',function(uiSpace){
      if (uiSpace.data.space == 'top') {
        new ContentEditor(
          $(editor.element.$), {
            wysiwyg: 'ckeditor',
            ckeditor: editor,
            consentPreferences: true,
            consentPreferencesButton: $(editor.element.$).find('.cke_button__preferences'),
          });
      }
    });
  },
}



//////////////////
// WEBPACK FOOTER
// ./vendor/ckeditor/plugins/preferences.js
// module id = /BdJ
// module chunks = 40